export function scrollElementIntoView(selector: string) {
    if ('scrollIntoView' in document.documentElement) {
        document.querySelector(selector)?.scrollIntoView({
            behavior: 'smooth',
        });
    } else {
        alert('Ihr Browser ist leider ein etwas älteres Modell. Bitte scrollen Sie manuell zum Anmeldeformular.');
    }
}
